import { render, staticRenderFns } from "./DadosContrapartida.vue?vue&type=template&id=4a84327b&scoped=true"
import script from "./DadosContrapartida.vue?vue&type=script&lang=js"
export * from "./DadosContrapartida.vue?vue&type=script&lang=js"
import style0 from "./DadosContrapartida.vue?vue&type=style&index=0&id=4a84327b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a84327b",
  null
  
)

export default component.exports